/**
 * Single source of truth for the vertical space the floating mobile bottom
 * navigation (mockup A) occupies, so every consumer — the bar itself, the
 * page content bottom padding and the toast offset — agrees on the same
 * number instead of three separately hand-tuned magic values.
 */

/** Height of the floating navy pill itself (also its per-entry min touch target). */
export const MOBILE_NAV_BAR_HEIGHT = 72;

/** Gap between the pill and the screen's bottom edge (the "floating" inset). */
export const MOBILE_NAV_BOTTOM_INSET = 16;

/** Breathing room between the pill's top edge and page content above it. */
export const MOBILE_NAV_CONTENT_GAP = 8;

/**
 * iOS Safari does not report the home-indicator safe-area inset correctly
 * when a PWA runs in standalone mode, so this extra padding is added by hand
 * (see `isIOSStandalonePwa`).
 */
export const MOBILE_NAV_IOS_PWA_EXTRA = 15;

/**
 * True when running as an iOS home-screen (standalone) PWA install, the one
 * case where the bottom safe-area inset needs the manual extra padding above.
 */
export function isIOSStandalonePwa(): boolean {
  const isStandalone = window.matchMedia("(display-mode: standalone)").matches;
  const isIOS = /iPad|iPod|iPhone/.test(window.navigator.userAgent);
  return isStandalone && isIOS;
}

/**
 * Total vertical clearance (in px) content and toasts need above the screen's
 * bottom edge to never sit behind the floating bottom navigation.
 */
export function getMobileNavClearance(): number {
  return (
    MOBILE_NAV_BAR_HEIGHT +
    MOBILE_NAV_BOTTOM_INSET +
    MOBILE_NAV_CONTENT_GAP +
    (isIOSStandalonePwa() ? MOBILE_NAV_IOS_PWA_EXTRA : 0)
  );
}
